import { Component } from '@angular/core';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

import { ArtWorkInterface } from "../../utils/interfaces/art-work.interface";
import { ImageModalComponent } from "../../components/image-modal/image-modal.component";
import { ResponsiveImageDirective } from "../../utils/directives/responsive-image.directive";

@Component({
  selector: 'app-works',
  standalone: true,
  imports: [
    ImageModalComponent,
    ResponsiveImageDirective,
  ],
  templateUrl: './works.component.html',
  styleUrl: './works.component.scss'
})
export class WorksComponent {
  selectedWork: ArtWorkInterface | null = null;
  isModalVisible = false;
  works: ArtWorkInterface[] = [];

  constructor(private sanitizer: DomSanitizer) {
    this.works = [
      {
        title: "Gryf i Jesiotr w akcji",
        description: this.sanitizeHtml(`
          <p>10 scen rzeźbiarskich</p>
          <p>brąz</p>
          <p>Szczecinek</p>
          <p><b>2024</b></p>
        `),
        images: ["images/gryfy/gryf_1.webp", "images/gryfy/gryf_2.webp", "images/gryfy/gryf_3.webp", "images/gryfy/gryf_4.webp", "images/gryfy/gryf_5.webp", "images/gryfy/gryf_6.webp", "images/gryfy/gryf_7.webp", "images/gryfy/gryf_8.webp", "images/gryfy/gryf_9.webp", "images/gryfy/gryf_10.webp"],
        layoutClass: "layout__gryfy"
      },
      {
        title: "Intymność",
        description: this.sanitizeHtml(`
            <p>11 x 10, 11 x 10,5 cm</p>
            <p>brąz</p>
            <p><b>2023</b></p>
            <div class="bottom-text">
                <p class="modal__text-bottom">Praca wykonana w Pracowni Medalierstwa prof. Hanny Jelonek na Wydziale Rzeźby ASP w Warszawie</p>
                <p class="modal__text-bottom"><small>fot. Piotr Hołubowicz</small></p>
            </div>
        `),
        images: ["images/intymnosc/intymnosc_1.webp", "images/intymnosc/intymnosc_2.webp", "images/intymnosc/intymnosc_3.webp"],
        layoutClass: "layout__intymnosc",
      },
      {
        title: "Medal Łukasz Zbroja",
        description: this.sanitizeHtml(`
          <p>12 x 11 cm / 17 x 14 cm</p>
          <p>brąz / gips ceramiczny</p>
          <p><b>2023</b></p>
          <p>Praca wyykonana w Pracowni Medalierstwa prof. Hanny Jelonek na wydziale Rzeźby ASP w Warszawie</p>
          <p>fot. Piotr Hołubowicz</p>`
        ),
        images: ["images/medal_lukasz_zbroja/medal_1.webp", "images/medal_lukasz_zbroja/medal_2.webp", "images/medal_lukasz_zbroja/medal_3.webp", "images/medal_lukasz_zbroja/medal_4.webp", "images/medal_lukasz_zbroja/medal_5.webp", "images/medal_lukasz_zbroja/medal_6.webp", "images/medal_lukasz_zbroja/medal_7.webp"],
        layoutClass: "layout__medal",
      },
      {
        title: "Medal Sepere Aude",
        description: this.sanitizeHtml(`
          <p>⌀ 8 cm</p>
          <p>brąz pozłacany</p>
          <p><b>2022</b></p>
          <p>fot. Piotr Hołubowicz</p>
        `),
        images: ["images/medal_sepere_aude/medal_1.webp", "images/medal_sepere_aude/medal_2.webp", "images/medal_sepere_aude/medal_3.webp"],
        layoutClass: "layout__sepere",
      },
      {
        title: "Portret Małej Dziewczynki",
        description: this.sanitizeHtml(`
          <p>32 x 22 cm</p>
          <p>glina</p>
          <p><b>2022</b></p>
          <p>fot. Piotr Mastalerz</p>
        `),
        images: ["images/portret_malej_dziewczynki/portret_1.webp", "images/portret_malej_dziewczynki/portret_2.webp", "images/portret_malej_dziewczynki/portret_3.webp", "images/portret_malej_dziewczynki/portret_4.webp", "images/portret_malej_dziewczynki/portret_5.webp", "images/portret_malej_dziewczynki/portret_6.webp"],
        layoutClass: "layout__portret"
      },
      {
        title: "Statuetka Stowarzyszenia Kin Studyjnych",
        description: this.sanitizeHtml(`
          <p>brąz</p>
          <p><b>od 2022</b></p>
          <p>fot. Maciej Lewandowski</p>
        `),
        images: ["images/statuetka_sks/statuetka_1.webp", "images/statuetka_sks/statuetka_2.webp"],
        layoutClass: "layout__sks",
      },
      {
        title: "Statuetka Anioł Dzieci Afryki Fundacji Dzieci Afryki",
        description: this.sanitizeHtml(`
          <p>brąz, marmur Namibian Rose, emalia</p>
          <p><b>od 2024</b></p>
          <p>fot. Piotr Hołubowicz</p>
        `),
        images: ["images/statuetka_aniol/statuetka_1.webp", "images/statuetka_aniol/statuetka_2.webp"],
        layoutClass: "layout__aniol",
      },
      {
        title: "Statuetka im. Igora Ostrowskiego",
        description: this.sanitizeHtml(`
        <p>brąz, marmur</p>
        <p><b>od 2025</b></p>
        <p>fot. Maciej Lewandowski</p>
        `),
        images: ["images/statuetka_igor/igor_1.webp", "images/statuetka_igor/igor_2.webp", "images/statuetka_igor/igor_3.webp"],
        layoutClass: "layout__igor"
      },
      {
        title: "Ślady Hasiora. Wyrwane z ziemi",
        description: this.sanitizeHtml(`
          <p>3,5 x 2,5 m / obwód koła 17 m</p>
          <p>beton</p>
          <p>Punkt widokowy Jankulakowski, Kotelnica Białczańska, Białka Tatrzańska</p>
          <p><b>2024</b></p>
          <p>współautorstwo</p>
          <p>
              <h5>Autorzy:</h5>
              <p>Agata Biały Julia Grabowska Jakub Hałas Kajetan Karkuciński Michalina Kaza Kacper Kokoszka Dana Kolasa Agata Kołtun Aleksander Łukasik Natalia Klara Marczewska Wiktoria Marucha Jerzy Mróz Zofia Pilich Emilia Ptach Kinga Smaczna-Łagowska Aleksandra Ulkowska</p>
              <p>Praca została zrealizowana we współpracy studentów i absolwentów Pracowni 44 prowadzonej przez prof. Adama Myjaka i dr Kingę Smaczną-Łagowską na Wydziale Rzeźby warszawskiej ASP. Inspirowana jest twórczością Władysława Hasiora. Na kompozycję składa się 7 postaci (postać o wymiarach 3,5 x 2,5 m), trzymających się za ręcę, w geście pokoju. Pomnik znajduje się przy wyciągu narciarskim, w punkcie widokowym Jankulakowskim, Białka Tatrzańska</p>
              <p>fot. Oksana Hvozdiuk</p>
          </p>
        `),
        images: ["images/zakopane/zakopane_1.webp", "images/zakopane/zakopane_2.webp", "images/zakopane/zakopane_3.webp", "images/zakopane/zakopane_4.webp", "images/zakopane/zakopane_5.webp", "images/zakopane/zakopane_6.webp", "images/zakopane/zakopane_7.webp", "images/zakopane/zakopane_8.webp"],
        layoutClass: "layout__zakopane",
      },
    ];
  }

  onImageClicked(work: ArtWorkInterface): void {
    this.selectedWork = work;
    this.isModalVisible = true;
  }

  closeModal(): void {
    this.isModalVisible = false;
  }

  private sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}

